angular
    .module('annexaApp')
    .component('annexaHrefPermissionRegInput',{
        templateUrl: './components/common/annexa-href-permission/annexa-href-permission-reg-input.html',
        controller:['$state', '$rootScope', 'AnnexaPermissionsFactory', function ($state, $rootScope, AnnexaPermissionsFactory) {
            var vm = this;

            vm.text = '';
            vm.diligenceProfile = undefined;
            vm.show = false;

            vm.canShow = function () {
            	var show = true;         
        		var userProfiles = [];   	
        		var registerProfiles = $linq(vm.registerEntry.profile).select(function (x) {
                    if (x.id) {
                        return x.id;
                    }
                }).toArray();
            	if(vm.registerEntry.entryType == 'OUTPUT') {
            		var viewOutput = AnnexaPermissionsFactory.havePermission('view_output_register', true);
            		var viewAllOutput = AnnexaPermissionsFactory.havePermission('view_all_output_register', true);
	        		if(viewOutput){
	        			userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
	        		}
	        		if(!viewAllOutput){
	        			var intersect = $linq(userProfiles).intersect(registerProfiles, "(x,y) => x == y").toArray();
	        			show = intersect.length > 0;
	        		}else {
	        			var excludedProfiles = (($rootScope.app.configuration && $rootScope.app.configuration.excluded_profiles_see_all_registers)?$rootScope.app.configuration.excluded_profiles_see_all_registers:[]);
	                    if(excludedProfiles && excludedProfiles.length > 0) {
	                    	var excludedOk = $linq(excludedProfiles).except(userProfiles, "(x,y) => x == y").toArray();
	                    	var intersect = $linq(excludedOk).intersect(registerProfiles, "(x,y) => x == y").toArray();
	                    	show = !intersect.length > 0;
	                    }
	                }
            	} else if(vm.registerEntry.entryType == 'INPUT'){
            		var viewInput = AnnexaPermissionsFactory.havePermission('view_input_register', true);
            		var viewAllInput = AnnexaPermissionsFactory.havePermission('view_all_input_register', true);
	        		if(viewInput){
	        			userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
	        		}
	        		if(!viewAllInput){
	        			var registerDiligProfiles = $linq(vm.registerEntry.entryDiligences).select(function (x) {
	                        if (x.diligenceProfile && x.diligenceProfile.id) {
	                            return x.diligenceProfile.id;
	                        }
	                    }).toArray();
	        			var intersectRegProfiles = $linq(userProfiles).intersect(registerProfiles, "(x,y) => x == y").toArray();
	        			var intersectDiligProfiles = $linq(userProfiles).intersect(registerDiligProfiles, "(x,y) => x == y").toArray();
	        			show = intersectRegProfiles.length > 0 || intersectDiligProfiles.length > 0;
	        		}else {
	        			var excludedProfiles = (($rootScope.app.configuration && $rootScope.app.configuration.excluded_profiles_see_all_registers)?$rootScope.app.configuration.excluded_profiles_see_all_registers:[]);
	                    if(excludedProfiles && excludedProfiles.length > 0) {
	                    	var excludedOk = $linq(excludedProfiles).except(userProfiles, "(x,y) => x == y").toArray();
	                    	var intersect = $linq(excludedOk).intersect(registerProfiles, "(x,y) => x == y").toArray();
	                    	show = !intersect.length > 0;
	                    }
	                }
            	}

                return show;
            }

            var getRegInputUrl = function() {
                if(!vm.diligenceProfile) {
                	if(vm.registerEntry.csv){
                		return $state.href('annexa.reg.view', { csv: vm.registerEntry.csv })
                	}else{
                		return $state.href('annexa.reg.input.entries.edit', { input: vm.registerEntry.id })
                	}
                } else {
                    var diligence = $linq(vm.registerEntry.entryDiligences).firstOrDefault(undefined, "x => x.diligenceProfile.id == " + vm.diligenceProfile);

                    if(diligence) {
                        return $state.href('annexa.reg.input.diligences.edit', { input: vm.registerEntry.id, diligence: diligence.id });
                    }

                    return '.';
                }
            }


            vm.redirect = function () {
                var url = "";
                if(vm.registerEntry.entryType == 'INPUT'){
                	url = getRegInputUrl(); 
                }else{
                	if(vm.registerEntry.csv){
                		url = $state.href('annexa.reg.view', { csv: vm.registerEntry.csv })
                	}else{
                		url = $state.href('annexa.reg.output.entries.edit', { output: vm.registerEntry.id });
                	}
                }

                window.open(url, '_blank');
            }

            this.$onInit = function () {
            	var organs = (($rootScope.app.configuration && $rootScope.app.configuration.valids_origin_register_organ && $rootScope.app.configuration.valids_origin_register_organ.organs)?$rootScope.app.configuration.valids_origin_register_organ.organs:[]);
                vm.show = vm.canShow();
            	if(organs && organs.length > 0){
                	if(vm.registerEntry.originRegisterOrgan && vm.registerEntry.originEntryNumber && $linq(organs).count("x => x == '"+vm.registerEntry.originRegisterOrgan+"'") > 0) {
                        vm.text = vm.registerEntry.originEntryNumber;
                    } else {
                        vm.text = vm.registerEntry.entryNumber;
                    }	
                }else{
                    vm.text = vm.registerEntry.entryNumber;
                }
            }
        }],
        bindings: {
            registerEntry: '='
        }
    })
    .component('annexaHrefPermissionDocument',{
        templateUrl: './components/common/annexa-href-permission/annexa-href-permission-document.html',
        controller:['AnnexaPermissionsFactory', '$state', '$rootScope', 'GlobalDataFactory', '$filter', '$scope', 'DccumentsFactory', function(AnnexaPermissionsFactory, $state, $rootScope, GlobalDataFactory, $filter, $scope, DccumentsFactory) {
            var vm = this;

            vm.text = '';

            vm.canShow = function () {
            	if(vm.document && vm.document.docStatus != 'ARCHIVED'){
	                if(AnnexaPermissionsFactory.havePermission('view_documents')) {
	                    if (vm.origin && _.contains(['THIRD', 'DILIGENCE', 'DOSSIER', 'TASK', 'SEC'], vm.origin)) {
	                        return true;
	                    }
	                    if(vm.origin != 'NOTIFICATION' && $state.current && $state.current.name && ($state.current.name == 'annexa.reg.input.entries.edit' || $state.current.name == 'annexa.reg.input.entries.new' || $state.current.name == 'annexa.reg.output.entries.new' || $state.current.name == 'annexa.reg.output.entries.edit' || $state.current.name == 'annexa.reg.view' || $state.current.name == 'annexa.reg.viewInput' || $state.current.name == 'annexa.reg.viewOutput' || $state.current.name == 'annexa.reg.viewByNumberInput') && AnnexaPermissionsFactory.havePermission('view_register_entry_documents')){
	                        return true;
	                    }
	                    if(vm.document && vm.document.profiles) {
	                        var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
	                        var documentProfiles = $linq(vm.document.profiles).select("x => x.profile.id").toArray();
	                        var intersect = $linq(userProfiles).intersect(documentProfiles, "(x,y) => x == y").toArray();
	                        var documentTypeProfilesTotalAcces = [];
	                        if(vm.document && vm.document.type && vm.document.type.id){
	                        	var dtype = $linq(GlobalDataFactory.documentTypes).firstOrDefault(undefined,"x => x.id == "+vm.document.type.id);
	                        	if(dtype && dtype.profilesTotalAcces){
	                        		var documentTypeProfilesTotalAcces = $linq(dtype.profilesTotalAcces).select("x => x.profile.id").toArray();
	                        	}
	                        } 
	                        var intersectDocType = $linq(userProfiles).intersect(documentTypeProfilesTotalAcces, "(x,y) => x == y").toArray();
	                        return intersect.length > 0 || intersectDocType.length > 0 ;
	                    } 
	                }
            	}
                return false;
            }
		
			vm.openDocument = function(){
				if(vm.document && vm.document.docStatus && vm.document.docStatus == 'ARCHIVED'){
            		if($state && $state.current && $state.current.name && $state.current.name == "annexa.archive.archive.see" && $rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.close_and_archive && $rootScope.app.configuration.close_and_archive.showArchivedDocument){
						$scope.showLoadingdiv = true;
		                var windowReference = window.open();
		                DccumentsFactory.getDocContent(vm.document.id).then(function (data) {
	                        $scope.showLoadingdiv = false;
	                        windowReference.location = data;
	                    }).catch(function (error) {
		                    $scope.showLoadingdiv = false;
		                    windowReference.close();
		                });
            		}
            	}
				
			}
			
			vm.canOpenDocument = function(){
				var canOpen = false;
				if(vm.document && vm.document.docStatus && vm.document.docStatus == 'ARCHIVED'){
            		if($state && $state.current && $state.current.name && $state.current.name == "annexa.archive.archive.see" && $rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.close_and_archive && $rootScope.app.configuration.close_and_archive.showArchivedDocument){
						canOpen = true;
            		}
            	}
				return canOpen;
			}
			
            vm.redirect = function () {
                window.open($state.href('annexa.doc.documents.view', { code: vm.document.id }), '_blank');
            }

            this.$onInit = function () {
                var properties = Array.isArray(vm.nameProperties) ? vm.nameProperties : [vm.nameProperties];

                _.forEach(properties, function(item) {
                    if(vm.text != '' && vm.document[item]) {
                        vm.text += ' ';
                    }
                    if(vm.document[item]){
                    	vm.text += vm.document[item];
                    }else if(item == 'seeDocument'){
                    	vm.text += $filter('translate')('global.literals.seeDocument');
                    }else{
                    	vm.text += vm.document[item];
                    }
                });
            }
        }],
        bindings: {
            document: '=',
            nameProperties: '=',
            origin: '@?',
            
        }
    })
    .component('annexaHrefPermissionDossier',{
        templateUrl: './components/common/annexa-href-permission/annexa-href-permission-dossier.html',
        controller:['AnnexaPermissionsFactory', '$state', '$rootScope', 'DialogsFactory', 'TramNewFactory', function(AnnexaPermissionsFactory, $state, $rootScope, DialogsFactory, TramNewFactory) {
            var vm = this;
            vm.show = false;
            vm.text = '';

            vm.canShow = function () {
            	if(vm.dossier && vm.dossier.dossierStatus && (vm.dossier.dossierStatus == 'ARCHIVED' || vm.dossier.dossierStatus == 'REJECTED' || vm.dossier.dossierStatus == 'TRANSFER')){
            		return false;
            	}else{
            		if(vm.dossier && typeof vm.dossier.restrictedAccessEMGDE !== 'undefined') {
            			return !vm.dossier.restrictedAccessEMGDE;
            		} else {
                		return vm.canView() || vm.canProcess();
            		}
            	}
            }
            
            vm.canProcess = function () {
                var haveProcessProfile = false;

                if(AnnexaPermissionsFactory.havePermission('process_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    var dossierProcessProfiles = [];
                    if(vm.dossier && vm.dossier.dossierTransactions) {
                        _.forEach(vm.dossier.dossierTransactions, function (dt) {
                            if(dt.processProfiles) {
                                _.forEach(dt.processProfiles, function (item) {
                                    dossierProcessProfiles.push(item.profile.id);
                                })
                            }
                        });
                    }
                    var intersect = $linq(userProfiles).intersect(dossierProcessProfiles, "(x,y) => x == y").toArray();

                    haveProcessProfile = intersect.length > 0;

                }

                return haveProcessProfile;
            }

            vm.getDossierTransaction = function () {
                var dossierTransaction;
                if(AnnexaPermissionsFactory.havePermission('process_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    if(vm.dossier && vm.dossier.dossierTransactions) {
                        _.forEach(vm.dossier.dossierTransactions, function (dt) {
                            if (dt.actual && dt.processProfiles) {
                                var dossierProcessProfiles = [];
                                _.forEach(dt.processProfiles, function (item) {
                                    dossierProcessProfiles.push(item.profile.id);
                                })
                                var intersect = $linq(userProfiles).intersect(dossierProcessProfiles, "(x,y) => x == y").toArray();
                                if (intersect.length > 0) {
                                    dossierTransaction = dt;
                                }
                            }
                        });
                    }
                }

                return dossierTransaction;
            }

            vm.canView = function () {
                var haveViewProfile = false;

                if(AnnexaPermissionsFactory.havePermission('see_all_dossier')) {
                	haveViewProfile = true;
                } else if(AnnexaPermissionsFactory.havePermission('view_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    if(vm.dossier && vm.dossier.procedure && vm.dossier.procedure.procedureViewProfiles) {
                        var dossierViewProfiles = $linq(vm.dossier.procedure.procedureViewProfiles).select("x => x.profile.id").toArray();

                        var intersect = $linq(userProfiles).intersect(dossierViewProfiles, "(x,y) => x == y").toArray();

                        haveViewProfile = intersect.length > 0;
                    }
                }

                return haveViewProfile;
            }

            vm.redirect = function () {
                if(vm.canProcess()){
                    var dossierTransaction = vm.getDossierTransaction();
                    if(dossierTransaction) {
                    	if(vm.dossier && vm.dossier.bigDossier){
	        	        	DialogsFactory.confirm('global.literals.bigDossierMessage', 'global.literals.bigDossierMessageConfirm')
	        	            .then(function (data) {
	                    		window.open($state.href('annexa.tram.pending.viewdossier', {dossier: vm.dossier.id, dossierTransaction: dossierTransaction.id}), '_blank');	            
	        	           }).catch(function (data) {
	        		               //Empty
	        		       });
                    	}else{
                    		window.open($state.href('annexa.tram.pending.viewdossier', {dossier: vm.dossier.id, dossierTransaction: dossierTransaction.id}), '_blank');
                    	}
                    }else{
                    	if(vm.dossier && vm.dossier.bigDossier){
	        	        	DialogsFactory.confirm('global.literals.bigDossierMessage', 'global.literals.bigDossierMessageConfirm')
	        	            .then(function (data) {
	        	            	window.open($state.href('annexa.tram.view.viewdossier', { dossier: vm.dossier.id, dossierTransaction: -1 }), '_blank');	            
	        	           }).catch(function (data) {
	        		               //Empty
	        		       });
                    	}else{
                    		window.open($state.href('annexa.tram.view.viewdossier', { dossier: vm.dossier.id, dossierTransaction: -1 }), '_blank');
                    	}
                    }
                }else{
                	if(vm.dossier && vm.dossier.bigDossier){
        	        	DialogsFactory.confirm('global.literals.bigDossierMessage', 'global.literals.bigDossierMessageConfirm')
        	            .then(function (data) {
        	            	window.open($state.href('annexa.tram.view.viewdossier', { dossier: vm.dossier.id, dossierTransaction: -1 }), '_blank');	            
        	           }).catch(function (data) {
        		               //Empty
        		       });
                	}else{
                		window.open($state.href('annexa.tram.view.viewdossier', { dossier: vm.dossier.id, dossierTransaction: -1 }), '_blank');
                	}
                }
            }

            this.$onInit = function() {
                vm.text = vm.dossier ? vm.dossier.dossierNumber : '';
                if(vm.dossier && vm.dossier.id && !vm.dossier.dossierTransactions){
                	TramNewFactory.getDossierTransactionByDossierId([vm.dossier.id]).then(function(data) {
                        if(data && data.length > 0 && data[0].id == vm.dossier.id) {
                        	vm.dossier.dossierTransactions =  data[0].dossierTransactions;
                        	vm.dossier.restrictedAccessEMGDE = data[0].restrictedAccessEMGDE;
                        	vm.show = vm.canShow();
                        }
                    }).catch(function (error) {
                    });
                } else if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.useEmgdeSecurityToFilter 
                        && $rootScope.app.configuration.useEmgdeSecurityToFilter.filterDossier && vm.dossier && typeof vm.dossier.restrictedAccessEMGDE === 'undefined') {
                	TramNewFactory.getRestrictedAccessEMGDE(vm.dossier.id).then(function(data) {
                    	if(data.hasOwnProperty('restrictedAccess')) {
                            vm.dossier.restrictedAccessEMGDE = data.restrictedAccess;
                    	}
                    	vm.show = vm.canShow();
                    }).catch(function (error) {
                        console.log(error);
                    });
                } else {
                    vm.show = vm.canShow();
                }
            }
        }],
        bindings: {
            dossier: '='
        }
    })
    .component('annexaHrefPermissionDossierTransaction',{
        templateUrl: './components/common/annexa-href-permission/annexa-href-permission-dossier-transaction.html',
        controller:['AnnexaPermissionsFactory', '$state', '$rootScope', function(AnnexaPermissionsFactory, $state, $rootScope) {
            var vm = this;

            vm.text = '';

            vm.canShow = function () {
            	if(vm.dossierTransaction && vm.dossierTransaction.dossier && vm.dossierTransaction.dossier.dossierStatus && (vm.dossierTransaction.dossier.dossierStatus == 'ARCHIVED' || vm.dossierTransaction.dossier.dossierStatus == 'REJECTED' || vm.dossierTransaction.dossier.dossierStatus == 'TRANSFER')){
            		return false;
            	}else{
	            	return canViewDossier() || canProcessDossier();
            	}
            }

            var canViewDossier = function(){
                var haveViewProfile = false;
                var haveGlobalProcessProfile = false;

                if(AnnexaPermissionsFactory.havePermission('see_all_dossier')) {
                	haveViewProfile = true;
                }else if(AnnexaPermissionsFactory.havePermission('view_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    var dossierTransactionViewProfiles = [];
                    if(vm.dossierTransaction && vm.dossierTransaction.dossier && vm.dossierTransaction.dossier.procedure && vm.dossierTransaction.dossier.procedure.procedureViewProfiles ){
                        dossierTransactionViewProfiles = $linq(vm.dossierTransaction.dossier.procedure.procedureViewProfiles).select("x => x.profile.id").toArray();
                    }

                    var intersect = $linq(userProfiles).intersect(dossierTransactionViewProfiles, "(x,y) => x == y").toArray();

                    haveViewProfile = intersect.length > 0;
                }

                if(AnnexaPermissionsFactory.havePermission('process_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();

                    if(vm.dossierTransaction && vm.dossierTransaction.globalProcessProfileIds) {
                        var intersect = $linq(userProfiles).intersect(vm.dossierTransaction.globalProcessProfileIds, "(x,y) => x == y").toArray();
                        haveGlobalProcessProfile = intersect.length > 0;
                    }
                }

                return haveViewProfile || haveGlobalProcessProfile;
            }

            var canProcessDossier = function(){
                var haveProcessProfile = false;

                if(AnnexaPermissionsFactory.havePermission('process_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    var dossierTransactionProcessProfiles = [];
                    if(vm.dossierTransaction && vm.dossierTransaction.processProfiles ){
                        _.forEach(vm.dossierTransaction.processProfiles, function (item) {
                            dossierTransactionProcessProfiles.push(item.profile.id);
                        })
                    }
                    var intersect = $linq(userProfiles).intersect(dossierTransactionProcessProfiles, "(x,y) => x == y").toArray();

                    haveProcessProfile = intersect.length > 0;
                }

                return haveProcessProfile;
            }

            vm.redirect = function () {
                if(canProcessDossier()) {
                    window.open($state.href('annexa.tram.pending.viewdossier', {
                        dossier: vm.dossierTransaction.dossier.id,
                        dossierTransaction: vm.dossierTransaction.id
                    }), '_blank');
                }else{
                    window.open($state.href('annexa.tram.view.viewdossier', {
                        dossier: vm.dossierTransaction.dossier.id,
                        dossierTransaction: vm.dossierTransaction.id
                    }), '_blank');
                }
            }

            this.$onInit = function() {
                vm.text = vm.dossierTransaction.dossier.dossierNumber;
            }
        }],
        bindings: {
            dossierTransaction: '='
        }
    })
    .component('annexaDeletePermissionDossier',{
        templateUrl: './components/common/annexa-href-permission/annexa-delete-permission-dossier.html',
        controller:['AnnexaPermissionsFactory', '$state', '$rootScope', 'DialogsFactory', 'TramNewFactory', function(AnnexaPermissionsFactory, $state, $rootScope, DialogsFactory, TramNewFactory) {
            var vm = this;

            vm.text = '';

            vm.canShow = function () {
                return vm.canProcess();
            }

            vm.canProcess = function () {
                var haveProcessProfile = false;

                if(AnnexaPermissionsFactory.havePermission('process_dossier')) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    var dossierProcessProfiles = [];
                    if(vm.dossier && vm.dossier.dossierTransactions) {
                        _.forEach(vm.dossier.dossierTransactions, function (dt) {
                            if(dt.processProfiles) {
                                _.forEach(dt.processProfiles, function (item) {
                                    dossierProcessProfiles.push(item.profile.id);
                                })
                            }
                        });
                    }
                    var intersect = $linq(userProfiles).intersect(dossierProcessProfiles, "(x,y) => x == y").toArray();

                    haveProcessProfile = intersect.length > 0;

                }

                return haveProcessProfile;
            }
            
            this.$onInit = function() {
                vm.text = vm.dossier ? vm.dossier.dossierNumber : '';
                vm.show = vm.canShow();
                if(vm.dossier && vm.dossier.id && !vm.dossier.dossierTransactions){
                	TramNewFactory.getDossierTransactionByDossierId([vm.dossier.id]).then(function(data) {
                        if(data && data.length > 0 && data[0].id == vm.dossier.id) {
                        	vm.dossier.dossierTransactions =  data[0].dossierTransactions;
                        	vm.show = vm.canShow();
                        }
                    }).catch(function (error) {
                    });
                }
            }
        }],
        bindings: {
            dossier: '=',
            deleteFunction: '='
        }
    })
    .component('annexaDeletePermissionReg',{
        templateUrl: './components/common/annexa-href-permission/annexa-delete-permission-reg.html',
        controller:['$state', '$rootScope', 'AnnexaPermissionsFactory', function ($state, $rootScope, AnnexaPermissionsFactory) {
            var vm = this;

            vm.text = '';
            vm.diligenceProfile = undefined;

            vm.canShow = function () {
                if(vm.registerEntry.entryType == 'OUTPUT') {
                    return (AnnexaPermissionsFactory.havePermission('view_output_register', true) || AnnexaPermissionsFactory.havePermission('view_all_output_register', true));
                }

                if(!AnnexaPermissionsFactory.havePermission('view_input_register', true) && !AnnexaPermissionsFactory.havePermission('view_all_input_register', true)) {
                    var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                    var registerProfiles = $linq(vm.registerEntry.entryDiligences).select(function (x) {
                        if (x.diligenceProfile && x.diligenceProfile.id) {
                            return x.diligenceProfile.id;
                        }
                    }).toArray();

                    var intersect = $linq(userProfiles).intersect(registerProfiles, "(x,y) => x == y").toArray();

                    vm.diligenceProfile = intersect.length > 0 ? intersect[0] : undefined;

                    return intersect.length > 0;
                }

                return true;
            }

            this.$onInit = function () {
            	vm.show = vm.canShow();
            }
        }],
        bindings: {
            registerEntry: '=',
            deleteFunction: '='
        }
    })